export const route_tab = [
    "admin-dashboard",
    "dashboard",
    "sales",
    "pos",
    "quotation",
    "order",
    "service",
    "purchase",
    "manufacturing",
    "inventory",
    "accounts",
    "hrpayroll",
    "reports",
    "crm",
    "delivery",
    "settings",
];

export const routerLogin = {
    dashboard: [{ label: "Dashboard", value: "dashboard", link: "/dashboard" }],
    sales: [
        { label: "Sales Dashboard", value: "sales_dashboard", link: "/sales-dashboard" },
    ],
    pos: [
        { label: "POS Entry", value: "pos_entry", link: "/pos/pos-entry" },
    ],
    quotation: [
        { label: "Quotation Dashboard", value: "quotation_dashboard", link: "/quotation/dashboard" },
    ],
    order: [
        { label: "Order Dashboard", value: "order_dashboard", link: "/order/dashboard" },
    ],
    service: [
        { label: "Service Dashboard", value: "service_dashboard", link: "/service/dashboard" },
    ],
    purchase: [
        { label: "Purchase Dashboard", value: "purchase_dashboard", link: "/purchase/dashboard" },
    ],
    manufacturing: [
        { label: "Manufacturing Entry", value: "production_entry", link: "/manufacturing" },
    ],
    inventory: [
        { label: "Inventory Dashboard", value: "inventory_dashboard", link: "/inventory/dashboard" },
    ],
    accounts: [
        { label: "Accounts Dashboard", value: "accounts_dashboard", link: "/accounts/dashboard" },
    ],
    hrpayroll: [
        { label: "HR & Payroll Dashboard", value: "hrpayroll_dashboard", link: "/hrpayroll/dashboard" },
    ],
    reports: [
        { label: "Reports Dashboard", value: "reports_dashboard", link: "/reports" },
    ],
    crm: [
        { label: "CRM Dashboard", value: "crm_dashboard", link: "/crm/dashboard" },
    ],
    delivery: [
        { label: "Delivery Dashboard", value: "delivery_dashboard", link: "/delivery/dashboard" },
    ],
    settings: [
        { label: "Settings Dashboard", value: "settings_dashboard", link: "/settings" },
    ],
    'admin-dashboard': [
        { label: "Admin Dashboard", value: "admin-dashboard", link: "/admin-dashboard" }
    ],
};